import axios from 'axios';
import { BASE_URL } from 'common/config/baseUrl';

export type TourGuidePublicContent = {
  key1: string;
  key2: string;
  contentType: 'text' | 'json';
  content: string;
  json: unknown | null;
  updatedAt: string;
};

// Separate axios instance: the app's normal client adds the Authorization
// header and 401-triggers-logout handling, but this endpoint authenticates
// via a static API key and a 401 here means a wrong key, not an expired
// session.
const publicApi = axios.create({
  baseURL: BASE_URL,
  headers: { 'X-Api-Key': 'tf_tour_c4de750006cf2fc8f301a144e0a4eabe' },
});
console.log('TourGuide API key', process.env.REACT_APP_TOUR_GUIDE_API_KEY ? 'present' : 'MISSING');
/** One entry, or null when that pair has no content (404). */
export async function getTourContent(
  key1: string,
  key2: string
): Promise<TourGuidePublicContent | null> {
  try {
    const { data } = await publicApi.get<TourGuidePublicContent>('/api/TourGuide/public/content', {
      params: { key1, key2 },
    });
    return data;
  } catch (e: any) {
    if (e?.response?.status === 404) return null;
    throw e;
  }
}

/** Every entry of one Key 1 (for example every step / language of a page). */
export async function getTourContents(key1: string): Promise<TourGuidePublicContent[]> {
  const { data } = await publicApi.get<{ key1: string; items: TourGuidePublicContent[] }>(
    '/api/TourGuide/public/contents',
    { params: { key1 } }
  );
  return data.items;
}
